<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Detalle Grupo Bebeficios</mat-card-title>
        </mat-card-header-->
        <mat-card-content>

            <form class="form-container" (ngSubmit)="onSubmitBenefitGroup(benefitGroupForm)" #benefitGroupForm="ngForm" >

                <mat-card class="general-wf-card" appearance="outlined">
                    <mat-card-header>
                        <mat-card-title>Datos Generales</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div id="container" class="formControl">
                                
                        <div class="control">
                            <mat-form-field class="imput-full-width">
                            <mat-label>Descripción de Grupo</mat-label>
                            <input type="text" matInput name="benefitGroup.description" [(ngModel)]="benefitGroup.description" >
                            </mat-form-field>
                        </div>

                        <div class="control"> 
                            <button mat-flat-button class="button buttonWidth" type="button" (click)="addBenefitConf()">
                            Agregar Benefico
                            </button>
                        </div>

                        </div>
                    </mat-card-content>
                </mat-card>
                <br>

                <div *ngFor="let benefitConfiguration of benefitGroup.benefitConfigurations; let listIndex = index">
                    <mat-card class="general-wf-card" appearance="outlined">
                        <mat-card-header>
                            <h4>Configuraciones de Beneficio</h4>
                        </mat-card-header>
                        <mat-card-content>
                            <div id="container" class="formControl">
                                
                                <div class="control">
                                    <mat-form-field class="controlWidth">
                                      <mat-label>Beneficio</mat-label>
                                      <mat-select [(ngModel)]="benefitConfiguration.benefit"  [compareWith]="compareBenefit" name="benefitConfiguration.benefit.description{{listIndex}}">
                                        @for (benefit of benefits ; track benefit.id) {
                                          <mat-option [value]="benefit">{{ benefit.description }}</mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="control">
                                    <mat-form-field class="imput-full-width">
                                    <mat-label>Descripción de beneficio</mat-label>
                                    <input type="text" matInput name="benefitConfiguration.description{{listIndex}}" [(ngModel)]="benefitConfiguration.description" >
                                    </mat-form-field>
                                </div>
    
                            </div>

                            <div id="container" class="formControlTA">
                                <div class="control">
                                    <mat-form-field class="controlWidthTextArea">
                                        <mat-label>Formula</mat-label>
                                        <textarea matInput placeholder="Formula" name="benefitConfiguration.formula{{listIndex}}" [(ngModel)]="benefitConfiguration.formula"></textarea>
                                        <mat-error>{{ violations['benefitConfiguration.formula{{listIndex}}'] }}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <table class="table-div-area">
                                <thead>
                                    <tr>
                                    <th>División / Área</th>
                                    <th *ngFor="let area of areas">{{ area.description }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let division of divisions; let rowIndex = index" [class.hovered-row]="hoveredRow === rowIndex">
                                    <td>{{ division.description }}</td>
                                    <td *ngFor="let area of areas; let colIndex = index"
                                        [class.hovered-col]="hoveredCol === colIndex"
                                        (mouseenter)="onMouseEnter(rowIndex, colIndex)"
                                        (mouseleave)="onMouseLeave()">
                                        <input type="checkbox"
                                        [checked]="isSelected(listIndex, division.id, area.id)"
                                        (change)="onCheckboxChange(listIndex, division, area, $event)"
                                        />
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </mat-card-content>
                    </mat-card>
                    <br>
                </div>
                
                <div class="formControl">
                    <div class="control">
                    <button mat-flat-button class="button buttonWidth">
                        {{(benefitGroup.id > 0)? 'Actualizar': 'Guardar'}}
                    </button>
                    </div>
                </div>
                
            </form>

    </mat-card-content>
</mat-card>